import { useState, useEffect } from "react";
import {
  FiltroCheckBody,
  FiltroCheckContainer,
  FiltroCheckElementos,
  FiltroCheckHeader,
} from "./localStyle";
import camelize from "global/utils/camelize";

const FiltroCheck = ({
  elementos,
  values,
  defaultValue,
  showValue,
  labelValue,
  onChange,
  title,
  htmlFor,
}) => {
  //#region  ----------- constants ---------------
  const seleccionarTodoInicial = values[0] === "Todos";
  const initializeSelectedElements = () => {
    const initialSelected = {};
    elementos.forEach((elemento) => {
      initialSelected[elemento[defaultValue]] =
        seleccionarTodoInicial || values.includes(elemento[defaultValue]);
    });
    return initialSelected;
  };

  const [seleccionarTodo, setSeleccionarTodo] = useState(
    seleccionarTodoInicial
  );
  const [elementosSeleccionados, setElementosSeleccionados] = useState(
    initializeSelectedElements()
  );
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const onChangeSeleccionarTodo = () => {
    const newSeleccionarTodo = !seleccionarTodo;
    setSeleccionarTodo(newSeleccionarTodo);

    const newElementosSeleccionados = {};
    elementos.forEach((elemento) => {
      newElementosSeleccionados[elemento[defaultValue]] = newSeleccionarTodo;
    });
    setElementosSeleccionados(newElementosSeleccionados);
    onChange(newSeleccionarTodo ? elementos.map((e) => e[defaultValue]) : []);
  };

  const createArray = (items) => {
    return Object.keys(items).filter((propiedad) => items[propiedad]);
  };

  const manejarCambioElemento = (nombre) => {
    const nuevosElementosSeleccionados = {
      ...elementosSeleccionados,
      [nombre]: !elementosSeleccionados[nombre],
    };
    setElementosSeleccionados(nuevosElementosSeleccionados);
    onChange(createArray(nuevosElementosSeleccionados));
    const todosSeleccionados = Object.values(
      nuevosElementosSeleccionados
    ).every((valor) => valor === true);
    setSeleccionarTodo(todosSeleccionados);
  };

  //#endregion --------- funciones ---------------

  //#region --------- useEffect ---------------
  useEffect(() => {
    if (seleccionarTodoInicial) {
      onChange(elementos.map((e) => e[defaultValue]));
    }
  }, []);
  //#endregion --------- useEffect ---------------

  return (
    <FiltroCheckContainer>
      <FiltroCheckHeader>
        <div className="FiltroCheckHeader-input">
          <input
            id={`checkbox-todos-${htmlFor}`}
            className="FiltroCheck-checkbox"
            type="checkbox"
            checked={seleccionarTodo}
            onChange={onChangeSeleccionarTodo}
          />
          <label htmlFor={`checkbox-todos-${htmlFor}`}>{title}</label>
        </div>
      </FiltroCheckHeader>
      <FiltroCheckBody>
        <FiltroCheckElementos>
          {elementos.map((elemento, index) => (
            <div className="FiltroCheckElemento" key={index}>
              <input
                className="FiltroCheck-checkbox"
                type="checkbox"
                id={`checkbox-${index}-${htmlFor}`}
                checked={!!elementosSeleccionados[elemento[defaultValue]]}
                onChange={() => manejarCambioElemento(elemento[defaultValue])}
              />
              <label htmlFor={`checkbox-${index}-${htmlFor}`}>
                <div className="FiltroCheckElemento-label">
                  <span className="FiltroCheckElemento-labelBlack">
                    {camelize(elemento[showValue])}
                  </span>
                  <span className="FiltroCheckElemento-labelBlue">
                    {elemento[labelValue]}
                  </span>
                </div>
              </label>
            </div>
          ))}
        </FiltroCheckElementos>
      </FiltroCheckBody>
    </FiltroCheckContainer>
  );
};

export default FiltroCheck;
